import { IEventViewBase } from '@core/interfaces/event/event-view-base.interface';
import { IPriceCategory } from '@core/interfaces/product/pricing-category.interface';
import { AAGUID, ISODateTime, parseArray } from '@interticket/core';
import { PriceCategory } from '../product/price-category.model';

export class EventViewBase implements IEventViewBase {

  readonly availableCapacity: number;
  readonly customersCountryIsEnabled: boolean;
  readonly endDate: ISODateTime;
  readonly id: AAGUID;
  readonly isFree: boolean;
  readonly isSoldout: boolean;
  readonly name: string;
  readonly priceCategories: PriceCategory[];
  readonly startDate: ISODateTime;

  constructor(iEvent: IEventViewBase) {
    this.availableCapacity = iEvent.availableCapacity;
    this.customersCountryIsEnabled = !!iEvent.customersCountryIsEnabled;
    this.endDate = iEvent.endDate;
    this.id = iEvent.id;
    this.isFree = !!iEvent.isFree;
    this.name = iEvent.name;
    this.priceCategories = parseArray<IPriceCategory, PriceCategory>(iEvent.priceCategories, PriceCategory);
    this.startDate = iEvent.startDate;

    this.isSoldout = this.getIsSoldout();
  }

  private getIsSoldout(): boolean {
    return !this.isFree && (this.availableCapacity === 0 || this.getIsSoldoutAllPriceCategories());
  }

  private getIsSoldoutAllPriceCategories(): boolean {
    return this.priceCategories.every(priceCategory => priceCategory.availableCapacity === 0);
  }

}
